import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from '@auth0/auth0-angular';
import { COOKIE_CONSENT_TEXT } from 'src/app/core/constants/cookie-consent.constants';
import { CookieConsentService } from 'src/app/services/cookie-consent/cookie-consent.service';

/**
 * Global analytics cookie consent banner (fallback used when no external CMP is configured).
 * Shown only AFTER login, and only until the user makes a choice. Accepting enables Pendo
 * analytics; declining keeps it off. The choice persists across sessions.
 */
@Component({
  selector: 'app-cookie-consent-banner',
  standalone: true,
  imports: [],
  templateUrl: './cookie-consent-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieConsentBannerComponent {
  readonly COOKIE_CONSENT_TEXT = COOKIE_CONSENT_TEXT;

  readonly isVisible;

  private readonly cookieConsent = inject(CookieConsentService);
  private readonly auth = inject(AuthService);
  private readonly isAuthenticated = toSignal(this.auth.isAuthenticated$, { initialValue: false });

  constructor() {
    // Only surface the consent banner once the customer is logged in.
    this.isVisible = computed(() => this.isAuthenticated() && this.cookieConsent.isBannerVisible());
  }

  onAccept(): void {
    this.cookieConsent.grantConsent();
  }

  onDecline(): void {
    this.cookieConsent.denyConsent();
  }
}
